// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"20f01c97","271":"28df01a3","453":"ded7abb7","594":"bf2503c2","746":"629710c8","844":"fab831d6","876":"e0bfbffa","929":"d739f8b7","968":"ea684985","980":"fc2bdb95","992":"e258f4e3"}[chunkId] + ".chunk.js";
};